import { IApplicationState } from '../../types/redux';
import { selectDictionaries } from './selectDictionaries';

export const selectAvailableBanks = (state: IApplicationState) => selectDictionaries(state).banks;
